@if (!carouselSlides()?.length) {
    <div class="home-page__skeleton--carousel">
        <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()" />
    </div>
} @else {
    <div class="carousels-wrapper">
        <lib-carousel
            class="home-page__carousel"
            overlayGradient="left"
            [slides]="carouselSlides()"
            (goToBrand)="goToBrand($event)"
        ></lib-carousel>
        @if (promoSlides()?.length) {
            <lib-promo-banner [slides]="promoSlides()"></lib-promo-banner>
        }
    </div>
}

@if (!isHomeConfigLoading() && firstSection()) {
    <section class="home-page box-container">
        <app-section-products [section]="firstSection()"></app-section-products>
    </section>
}
@if (!isHomeConfigLoading() && brandConfigs()?.length) {
    <section class="split-banners">
        <app-split-banners [brands]="brandConfigs()"></app-split-banners>
    </section>
}
@for (section of restSections(); track section) {
    <section class="home-page box-container">
        <app-section-products [section]="section"></app-section-products>
    </section>
}
